<template>
    <div class="problem-detail">
        <p class="fs_36 c_1a lh_40">{{infos.title}}</p>
        <p class="fs_24 c_98 mt_10 lh_40">更新于：{{infos.create_time}}</p>
        <div class="mt_40" v-html="infos.content">{{infos.content}}</div>
    </div>
</template>
<script>
export default {
    name:"ProblemDetail",
    data(){
        return{
            infos:{}
        }
    },
    mounted(){
        this.axios.post('/wechat.php/Question/getQuestionDetail',{
            question_id:this.$route.params.id
        }).then(
            res=>{
                if(res.data.code==1){
                    res.data.data.data.content=res.data.data.data.content.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
                    this.infos=res.data.data.data;
                }
            }
        )
    }
}
</script>
<style scoped>
.problem-detail{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    padding: 30px;
    background: #fff;
    overflow: auto;
}
</style>





// WEBPACK FOOTER //
// src/pages/mine/ProblemDetail.vue